import React from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
// Constants
import { WEB_SERVICE_MIMS } from "../../../../config/constants";
// Components
import Axios from "../../../../config/axios";
import { DeleteSessionDiv, DeleteText, BackAndDeleteDiv, BackButton, DeleteButton } from "./styles";

const DeleteSession = ({
  setIsShowingDeleteSession,
  software,
  sessionId,
  toggleRechargeReports,
  setToggleRechargeReports,
  setIsLoadingReports,
}) => {
  const [t] = useTranslation("global");

  const handleSetShowDeleteSession = (e) => {
    e.preventDefault();
    setIsShowingDeleteSession(false);
  };
  const handleDeleteSession = (e) => {
    e.preventDefault();
    setIsShowingDeleteSession(false);
    Axios("put", `${WEB_SERVICE_MIMS}/patients/sessions/delete/${software}/${sessionId}`)
      .then(({ data }) => {
        if (data.deletedSession) {
          setIsLoadingReports(true);
          setToggleRechargeReports(!toggleRechargeReports);
          toast.success(t("reports.deleteSession.deletedSessionMessage"));
        } else {
          toast.error(t("profileMessage.sendDataMessage"));
        }
      })
      .catch((error) => {
        toast.error(t("reports.deleteSession.errorMessage"));
        console.log("url error: ", error);
      });
  };

  return (
    <DeleteSessionDiv>
      <DeleteText>{t("reports.deleteSession.deleteSessionText")}</DeleteText>
      <BackAndDeleteDiv>
        <BackButton onClick={handleSetShowDeleteSession}>{t("reports.deleteSession.backButton")}</BackButton>
        <DeleteButton onClick={handleDeleteSession}>{t("reports.deleteSession.deleteButton")}</DeleteButton>
      </BackAndDeleteDiv>
    </DeleteSessionDiv>
  );
};

export default DeleteSession;
